import * as Dialog from '@radix-ui/react-dialog';
import { useRef } from 'react';
import { Button } from '@/components/ui/form/button';
import { BottomSheetProps } from './bottom-sheet.types';
import styles from './bottom-sheet.module.less';

export function BottomSheet({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
  confirmLabel = 'Continue',
  cancelLabel = 'Go back',
  onConfirm,
  confirmVariant = 'primary',
  confirmDisabled = false,
}: BottomSheetProps) {
  const openerRef = useRef<HTMLElement | null>(null);

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className={styles.overlay} />

        <Dialog.Content
          className={styles.sheet}
          onOpenAutoFocus={(event) => {
            const content = event.currentTarget;
            const opener = document.activeElement;
            if (
              content instanceof HTMLElement &&
              opener instanceof HTMLElement &&
              !content.contains(opener)
            ) {
              openerRef.current = opener;
            }
          }}
          onCloseAutoFocus={(event) => {
            if (!openerRef.current?.isConnected) return;
            event.preventDefault();
            openerRef.current.focus();
          }}
        >
          <div className={styles.body}>
            <div className={styles.header}>
              <Dialog.Title className={styles.title}>{title}</Dialog.Title>
              {description && (
                <Dialog.Description className={styles.description}>
                  {description}
                </Dialog.Description>
              )}
            </div>

            {children && <div className={styles.content}>{children}</div>}
          </div>

          <div className={styles.footer}>
            {footer ?? (
              <div className={styles.actions}>
                {onConfirm && (
                  <Button
                    variant={confirmVariant === 'danger' ? 'danger' : 'primary'}
                    fullWidth
                    disabled={confirmDisabled}
                    onClick={onConfirm}
                  >
                    {confirmLabel}
                  </Button>
                )}
                <Dialog.Close asChild>
                  <Button variant="secondary" fullWidth>
                    {cancelLabel}
                  </Button>
                </Dialog.Close>
              </div>
            )}
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
